"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M15.4652 15.5529c.4105.3695.4437 1.0018.0743 1.4123-.3695.4105-1.0018.4437-1.4123.0743l-5.2557-4.705c-.4414-.3972-.4414-1.0893 0-1.4866l5.2557-4.6316c.4105-.3695 1.0428-.3362 1.4123.0743.3694.4105.3362 1.0428-.0743 1.4122l-4.4299 3.8884 4.4299 3.9617Z", clipRule: "evenodd" })), 'ArrowLeftSmallIcon');
